<template>
    <div id="home" class="backing">
        <v-app>
        <v-container fluid class="container-inner" fill-height>
            <v-row>
                <v-col cols="12">
            <Masthead/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
            <NavBar/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <div>
                        <slot name="aboutDan"/>
                        <strong>Daniel Field Schmidt</strong>
                        <br />
                        11/5/1949 -- 3/8/1988
                        <div>
                            <img src="../assets/site-images/danielfieldschmidt.jpg" class="danPhoto">
                        </div>
                        </div>
                </v-col>
                <v-col cols="12" md="8">
                    <div>
                        <slot />
                    </div>
                </v-col>
            </v-row>

            <v-row align="stretch">

                <v-col
                        cols="12"
                        md="6"
                        lg="4"
                >
                    <v-card
                    height = "auto">
                        <v-card-title>
                            <a href="/Photos" class="cardTitle">Photo gallery  &nbsp;&raquo;&raquo;</a>
                        </v-card-title>
                        <v-card-text>
                            <a href="/Photos"><img src="/photos/gallery_promo.jpg" class="danPhoto"></a>
                            <div>Do you have photos of Dan or his art that aren't included here? <a href="mailto:jim3@jimwcoleman.com?subject=Dan Schmidt site">Email them</a> and they will be included.</div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                        cols="12"
                        md="6"
                        lg="4"
                >
                    <v-card>
                        <v-card-title></a>
                            <a href="#"  class="cardTitle">Friends &amp; Family  &nbsp;&raquo;&raquo;</a>
                        </v-card-title>
                        <v-card-text>
                            <a href="/Photos"><img src="/photos/dan_and_barb.jpg" class="danPhoto"></a>
                            <div>Dan was married to the love of his life, Barbara Nell Coleman. Barb passed away July 5, 2019 after having lived 31 years without her beloved husband.</div>
                            <p><i>Coming soon...</i></p>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                        cols="12"
                        md="6"
                        lg="4"
                >
                    <v-card>
                        <v-card-title>
                            <a href="/works"  class="cardTitle">Other works  &nbsp;&raquo;&raquo;</a>
                        </v-card-title>
                    <v-card-text>
                        Aside from his paintings, Dan enjoyed writing and other creative pursuits. You never know what you'll find in here...
                    <div style="font-weight: bold; color: red">NEW</div>
                    </v-card-text>
                </v-card>

                </v-col>

            </v-row>
            <FooterBar/>
        </v-container>
        </v-app>
    </div>
</template>

<script>
    import NavBar from '@/components/NavBar'
    import FooterBar from '@/components/FooterBar'
    import Masthead from '@/components/Masthead'
    export default {
        name: 'Home',
        data () {
            return {
                alignment: 'center',
                dense: false,
                justify: 'center',
            }
        },
        components: {
            NavBar,
            FooterBar,
            Masthead
        }
    }
</script>

<style scoped>
    .backing {
        background-color: #ccc;
    }
    .cards {
        .min-height: 3000px;
    }
    .container-inner {
        max-width: 1200px;
        background-color: #fff;
    }
    .danPhoto {
        max-width: 250px;
        height: auto;
        margin-top: 2em;
    }
    .cardTitle {
        text-decoration: none;
    }
</style>
